import { Component, OnInit,ElementRef,ViewChild } from '@angular/core';
import { GridBaseCase } from "../../grid/grid.base.case";
import { ActivatedRoute, Router } from '@angular/router';
import { PlatformLocation } from '@angular/common';
import { Platform } from '@ionic/angular';
import { MessageclientService } from '../../../../service/messageclient.service';
import { CommonService } from '../../../../service/common.service';
import { WebParameterContext,WebResponesContext } from '../../../../model/common';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { BaseCase } from '../../../basecase';
import { MapclientServiceService } from '../../../../service/mapclient.service.service';
import { EmitserviceService } from "../../../../service/emitservice.service";
import { SysAccount } from 'src/model/sys.account';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
declare var wx: any;//启用微信客户端
declare var app;
@Component({
  selector: 'app-mz-button-status',
  templateUrl: './mz-button-status.component.html',
  styleUrls: ['./mz-button-status.component.scss']
})
export class MzButtonStatusComponent extends GridBaseCase {
  work: boolean = true;
  locationError: boolean = false;
  locationObject:any = {};
  a_id:any;
  arrlist:any = {};
  qrcode_url: any =null;
  isModalshow:boolean;
 
  @ViewChild('map') map_container: ElementRef;
  constructor(
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    private http: HttpCustomerService,
    public baseService: BaseCase,
    private activaRouter: ActivatedRoute,
    private iab: InAppBrowser,
    private map: MapclientServiceService,
    private platform: Platform,
    private emitservice: EmitserviceService
  ) { super(); }

  LoadData() {

    let getID = this.activaRouter.snapshot.paramMap.get('id');
    if (getID) {
      if (getID.split('&').length > 1) {
        this.work = false;
      }
    }
  }
 
  getAction(btn, url) {
    let that = this;
    wx.hideOptionMenu();
    let inHomeMessage:string="上班之后才可以操作";//未上班提示
    let onHomeMessage:string="已下班不可操作";//下班后操作
    let onHomeAfter:string = "下班后才可操作";//下班后操作
    let inhome:string="已上班";//已上班
    let onHome:string="已下班";//已下班
    let isdz:boolean=false;
    that.com.GetAccount.Roles.forEach(role=>{
      if(role.Code=="1003"){//如果是督导
        isdz=true;
      }
    });
    if(isdz){
      inHomeMessage="进店之后才可以操作";
      onHomeMessage="已离店不可操作";
      onHomeAfter="离店后才可操作";
      inhome="已进店";
      onHome="已离店";
    }
    let info = that.com.GetStorageKey("pginfo");
    if (info) {
      if (info.a_StartDate) {
        localStorage.setItem("pgindata", "true");
      }
      if (info.a_EndDate) {
        localStorage.setItem("pgondate", "true");
      }
    }
    if (that.element.employLimit) {
      if (that.element.employLimit == "work") {//上班之后，下班之前才可以操作
        if (!localStorage.getItem("pgindata")) {//未上班
          that.msg.Alert(inHomeMessage);
          return;
        }
        if (localStorage.getItem("pgondate")) {//已经离店
          that.msg.Alert(onHomeMessage);
          return;
        }
      }
      if (that.element.employLimit == "gowork") {//上班后可用
        if (!localStorage.getItem("pgindata")) {//未上班
          that.msg.Alert(inHomeMessage);
          return;
        }
      }
      if (that.element.employLimit == "afterwork") {//下班后可用
        if (!localStorage.getItem("pgondate")) {//未下班不可使用
          that.msg.Alert(onHomeAfter);
          return;
        }

      }
    }
    if (btn == "a_ClockIn") {//上班并且下班提示已下班
      if (localStorage.getItem("pgindata") && localStorage.getItem("pgondate")) {
        that.msg.Alert(onHome);
        return;
      } else if (localStorage.getItem("pgindata")) {//上班
        that.msg.Alert(inhome);
        return;
      }
    }
    if (btn == "a_AfterWork") {//下班
      // if (localStorage.getItem("pgondate")) {//已经离店
      //   that.msg.Alert("已下班");
      //   return;
      // }
       const that = this;
        if (!localStorage.getItem("pgindata")) {
          that.msg.Alert("请先上班"); 
          return;
         }
    }
    if (btn == "homing") {//扫码归巢，打开pg二维码
      console.log("扫码归巢");
      let that = this;
        //    that.com.GetAccount.Qrcode="/uploads/Snc/a172hrs_105107.jpg";
        //  if(!that.com.GetAccount.Qrcode){
        //     that.SNCInfo();
        //  }else{
        //    that.com.setHistoryUrl(false);
        //    that.com.removeItem(["homing","product","meminfo"]);
        //    let _imgurl:any = that.com.GetAccount.Qrcode.replace("/placeholder","");
        //    let _url:any=app.WEBURL+"/"+_imgurl;
        //    that.com.goQrCode(_url,"qrcode");
        //  }
        let body = new WebParameterContext();
        body.ConfigName = "SNCQrcodeManage";
        body.OpType = "QUERY";
        body.ConfigType = "form";
        // body.RowsPerPage = app.RowsPerPage;
        // body.PageNumber = 1;
        body.Client.PageName = "QrcodeManage";
        body.Client.ApiType = "Element";
        body.Client.ClientType = 2;
    
     
        that.http.post(app.DEFAULTURL, body).then(data => {
          console.log(data);
          // that.msg.Alert("返回会员信息:"+data.Status);
          if (data.ResponseMessage.Success) {
            data.Status=data.Status||[{},{}];
            if( data.Status.length <= 1){
              that.arrlist = data.Status[0];
              console.log(that.arrlist.qrcode_url.length)
              if(that.arrlist.qrcode_url){
                that.com.setHistoryUrl(false);
                   that.com.removeItem(["homing","product","meminfo"]);
                that.qrcode_url =that.arrlist.qrcode_url;
                that.com.goQrCode(that.qrcode_url,"qrcode");
              }else{
                that.msg.Alert("未查询到巢妈团二维码，请联系客服");
              }
            }else{
              that.msg.Alert("未查询到巢妈团二维码，请联系客服");
            }
              
          } else {
            that.msg.Alert(data.ResponseMessage.ErrorMessage);
          }
        }).catch(error => {
          that.msg.Alert("未查询到巢妈团二维码，请联系客服");
        });
      return;
    }
    that.com.setHistoryUrl(false);
    if (btn == "storeAddress") {//门店地址反馈
      if (that.com.GetStorageKey("tbstore")) {
        that.com.Go(url + "/" + that.com.GetStorageKey("tbstore").ID + "&" + that.com.getNowDatetime);
        return;
      }

    }

   
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let _btn = {};
    _btn["name"] = btn;
    _btn["pagename"] = PageName;
    _btn["temp"] = that.template.name;
    _btn["coverType"] = that.element.coverType ? that.element.coverType : "none";//覆盖数据方式
    localStorage.setItem("btn", JSON.stringify(_btn));
    // console.log("12121212");
    // console.log(that.template);
    // console.log(that.com.GetStorageKey("temppage"));
    //判断是否是采集数据
    const tempPageData: Array<any> = that.com.GetStorageKey("temppage");
    if (tempPageData) {
      const itemData: any = tempPageData.find(item => item.name.trim() == PageName && item.module.trim() == that.template.name.trim() && item.element.name.trim() == btn.trim());
      if (itemData) {
        localStorage.setItem("btncaiji", "1101");//表示是采集数据
      }
    }

    if (url) {
      // if(btn=="a_ClockIn"){//上班
      //   const info = that.com.GetStorageKey("pginfo")||{};
      //   if(info["a_StartDate"]){
      //     that.msg.Alert("已上班");
      //     return;
      //   }

      // }
      // if(btn=="a_AfterWork"){//下班
      //   const info = that.com.GetStorageKey("pginfo")||{};
      //   if(info["a_EndDate"]){
      //     that.msg.Alert("已下班");
      //     return;
      //   }

      // }
      if (btn == "a_QianDao") {//分销检查
        that.msg.Loading("数据检测中,请稍后...").then((load) => {
          that.BindInit().then((data) => {
            load.dismiss();
            if (data.Datas.length > 0) {
              if (data.Datas[0].a_Stats == 200) {//表示识别成功
                //跳转页面
                // that.router.navigate(["/tabs/contact/RowInspectionResult/query/" + data.Datas[0].a_ID + "&" + that.com.getNowDatetime]);
                that.com.Go("/tabs/contact/RowInspectionResult/query/" + data.Datas[0].a_ID + "&" + that.com.getNowDatetime);
              } else {
                if (document.getElementsByName("save_img")[0]) {
                  document.getElementsByName("save_img")[0].style.display = "block";
                }
                let msg: string = "图像&，请5分钟后回来查看，谢谢！";
                let code = data.Datas[0].a_Stats;
                if (code == 201 || code == 202 || code == 203 || code == 204 || code == 207 || code == 208 || code == 212) {//token不正确
                  msg = data.Datas[0].a_remark || "系统错误";
                } else {
                  msg = msg.trim().replace("&", data.Datas[0].a_remark || "识别中...");
                }
                localStorage.setItem("remark", msg);//展示消息内容
                // that.router.navigate([url + "/" + data.Datas[0].a_ID + "&" + that.com.getNowDatetime]);
                that.com.Go(url + "/" + data.Datas[0].a_ID + "&" + that.com.getNowDatetime);
              }
            } else {
              // this.router.navigateByUrl(url + "/&" + that.com.getNowDatetime);
              this.com.Go(url + "/&" + that.com.getNowDatetime);
            }
          }).catch(errr => {
            load.dismiss();
            // console.log(errr);
            this.msg.Show("系统错误,请联系系统管理员", "middle");
          });
          load.present();
        });
      } else if (btn == "examList" || btn == "storeFeedback") {
        // this.router.navigateByUrl(url + "/" + that.com.getNowDatetime);
        this.com.Go(url + "/" + that.com.getNowDatetime);
      } else if (btn == "a_XinKe" || btn == "link04")//拜访计划
      {
        let car = document.getElementsByTagName("app-grid-calendar");
        if (car.length > 0) {
          for (let i = 0; i < car.length; i++) {
            (function (i) {
              car[i].remove();
            })(i);
          }
        }
        that.com.Go(url + "/type/" + that.com.getNowDatetime);
      } else if (btn == "a_ProductInventory") {//产品库存管理
        let _role = null;
        if (this.com.GetAccount.Roles) {
          this.com.GetAccount.Roles.forEach(role => {
            _role = role.Code;
          });
        }
        const tbstore = that.com.GetStorageKey("tbstore");
        let _storeId = tbstore ? tbstore["ID"] : "";
        if (_role == '1002' && _storeId) {
          that.com.Go("/tabs/contact/ProductInventoryList/view/" + _storeId + "&" + that.com.getNowDatetime);
        } else {
          that.com.Go("/tabs/contact/ProductStoreList/view/" + that.com.getNowDatetime);
        }
      } else if (btn == "GiftView") {//赠品查看
        let _role = null;
        if (this.com.GetAccount.Roles) {
          this.com.GetAccount.Roles.forEach(role => {
            _role = role.Code;
          });
        }
        const tbstore = that.com.GetStorageKey("tbstore");
        let _storeId = tbstore ? tbstore["ID"] : "";
        if (_role == '1002' && _storeId) {
          that.com.Go("/tabs/contact/GiftView/view/" + _storeId + "&" + that.com.getNowDatetime);
        } else {
          that.com.Go("/tabs/contact/GiftStoreList/view/" + that.com.getNowDatetime);
        }
      } else if (btn == "a_ScanCode") {//扫码销量
        that.com.Go("/tabs/contact/ScanCodeSales/add/&" + that.com.getNowDatetime);
      } else if (btn == "a_ClockIn" || btn == "a_AfterWork") {
        const obj = {
          type:"clockIn",
          lat:0,
          lng:0,
          Address:null,
          InDeviationNumber:0,
          isLocationSucess:false
        };
        localStorage.setItem("clockLocation",JSON.stringify(obj));
        // that.com.setHistoryUrl();
        // that.router.navigateByUrl(url + "/" + that.com.getNowDatetime);
        if (btn == "a_ClockIn") {
          that.msg.Confirm("确认上班？").then(data => {
            if (data) {
              that.clockIn(url);
            }
          })
        }
        if (btn == "a_AfterWork") {
            const body = new WebParameterContext();
            body.ConfigName = "GetToDayMemberCare";
            body.OpType = "query";
            body.ConfigType = "view";
            body.Client.ApiType = "Element";
            body.Client.ClientType = 2;
            body.RequestBody = JSON.stringify({"Type":2});
            that.msg.Loading("数据加载中,请稍后").then(load=>{
            that.http.post(app.DEFAULTURL, body).then(data => {
                load.dismiss();
                if (data.ResponseMessage.Success) {
                  if(data.ResponseMessage.ErrorMessage){
                    that.msg.Alert(`${data.ResponseMessage.ErrorMessage}`,"系统提示","确定",true,"classlf");
                  }else{
                    that.msg.Confirm("确认下班？").then(data => {
                      if (data) {
                        that.clockOut(url);
                      }
                    })
                  }
                }else{
                  that.msg.Confirm("确认下班？").then(data => {
                    if (data) {
                      that.clockOut(url);
                    }
                  })
                }
            }).catch(err=>{
              load.dismiss();
              that.msg.Confirm("确认下班？").then(data => {
                if (data) {
                  that.clockOut(url);
                }
              })
            });
            load.present();
          });
        }
      }else if(btn=="a_ProductDistribution"){//产品分销
        sessionStorage.removeItem("catlist");
        if (url.indexOf("http") > 0) {
          if (this.element.elementInfo.title) {
            this.com.goWebPage(url, this.element.elementInfo.title);
          } else {
          }
        } else {
          if (url.split('/').length == 4 || url.split('/').length == 5) {
            that.com.Go(url + "/" + that.com.getNowDatetime);

          } else if (url.split('/').length == 6) {
            if (url.indexOf('&') == "-1") {
              that.com.Go(url + '&' + that.com.getNowDatetime);
            } else {
              // that.router.navigate([url + that.com.getNowDatetime]);
              that.com.Go(url + that.com.getNowDatetime);
            }
          } else {
            if(url.substring(url.length-1,url.length)=="/"){
              that.com.Go(url+"&"+that.com.getNowDatetime);
            }else{
              that.com.Go(url+"/"+that.com.getNowDatetime);
            }
            
          }
        }
      }else if(btn=="sncshequnzhaoxin"){//snc会员招新
        // debugger;
          let _url = decodeURIComponent(url);
          let tb=that.com.GetStorageKey("pginfo")||{};
          let userinfo = that.com.GetAccount;
            _url= _url.replace("{0}",tb.c_Code);//门店编号
            _url=_url.replace("{1}",userinfo.CustomerID);//导购编码
            _url=_url.replace("{2}",userinfo["Mobile"]);//手机号码
            if(userinfo["backurl"]){
              _url=_url.replace("{3}",encodeURIComponent(userinfo["backurl"]));//pginfo
            }
            sessionStorage.setItem("storeback",_url);
            that.iab.create(_url);
            setTimeout(() => {
              sessionStorage.removeItem("storeback");
            }, 3000);
        // setTimeout(()=>{//https://nestle.aven90.cn/app/index.php?i=3&c=entry&m=nestle_ssr&do=wechat_qy&store_number=xxxxx&serial_number=xxxxx&mobile=138xxxxxxxx&backurl=http://xxxxxx
        //   that.msg.Confirm("确定跳转到第三方页面吗？","取消","确定").then(res=>{
          
        //     that.iab.create("https://nestle.aven90.cn/app/index.php?i=3&c=entry&m=nestle_ssr&do=wechat_qy&store_number=Test001&serial_number=SNC001&mobile=13000000000&backurl=http://xxxxxx");
        //   });
        // },100);
      }else if(btn=="snchuodong"){ // 活动
        let _url = decodeURIComponent(url);
          let tb=that.com.GetStorageKey("pginfo")||{};
          let userinfo = that.com.GetAccount;
            _url= _url.replace("{0}",tb.c_Code);//门店编号
            _url=_url.replace("{1}",userinfo.CustomerID);//导购编码
            _url=_url.replace("{2}",userinfo["Mobile"]);//手机号码
            if(userinfo["backurl"]){
              _url=_url.replace("{3}",encodeURIComponent(userinfo["backurl"]));//pginfo
            }
            sessionStorage.setItem("storeback",_url);
            console.log(_url,"地址地址地址");
            that.iab.create(_url);
            setTimeout(() => {
              sessionStorage.removeItem("storeback");
            }, 3000);
      }
      else if(btn=="SharingPlatform"){ // 活动
         wx.showOptionMenu();
        let _url = decodeURIComponent(url);
          let userinfo = that.com.GetAccount;
            _url= _url.replace("{0}",userinfo["Mobile"]);//手机号
            _url=_url.replace("{1}",userinfo["Id"]);//当前人id
           
            sessionStorage.setItem("storeback",_url);
            console.log(_url,"地址地址地址");
            that.iab.create(_url);
            setTimeout(() => {
              sessionStorage.removeItem("storeback");
            }, 3000);
      }
      else {
        if (url.indexOf("http") > 0) {
          if (this.element.elementInfo.title) {
            this.com.goWebPage(url, this.element.elementInfo.title);
          } else {
          }
        } else {
          if (url.split('/').length == 4 || url.split('/').length == 5) {
            // that.router.navigateByUrl(url + "/" + that.com.getNowDatetime);
            that.com.Go(url + "/" + that.com.getNowDatetime);
          } else if (url.split('/').length == 6) {
            if (url.indexOf('&') == "-1") {
              that.com.Go(url + '&' + that.com.getNowDatetime);
            } else {
              that.com.Go(url + that.com.getNowDatetime);
            }
          } else {
            if(url.substring(url.length-1,url.length)=="/"){
              that.com.Go(url+"&"+that.com.getNowDatetime);
            }else{
              that.com.Go(url+"/"+that.com.getNowDatetime);
            }
            
          }
        }
      }

    } else {
      this.msg.Show("暂未开通", "middle");
    }
  }
  BindInit(): Promise<any> {
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.ConfigName = "TBProductCheckMasterXML";//总表
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = 1;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = "Element";
    body.Client.ClientType = 2;
    body.SpecialParameter = "TBProductCheckMasterXML";
    let _obj = {};
    _obj["a_FK_SystemUser_ID"] = that.com.GetAccount.Id;
    _obj["a_FK_TBStore_ID"] = that.com.GetStorageKey("tbstore")["ID"];
    // _obj["a_TaskDate"]=that.com.getNow;
    body.RequestBody = JSON.stringify(_obj);
    return new Promise<any>((resolve, reasole) => {
      that.http.post(app.DEFAULTURL, body).then(data => {
        // console.log(data);
        // that.baseService.arrayData = [];
        if (data.ResponseMessage.Success) {
          resolve(data.Status);
        } else {
          reasole(data);
        }
      }).catch(error => {
        reasole(error);
      });
    });
  }


  /**
   * 获取门店坐标得方法
   * @param type 考勤类型 0 上班  1 下班
   * @param state 打卡状态 0 失败  1 成功
   * @param obj 
   */
   CloinId(type:number,state:number,obj:any={},long:any=0,lat:any=0,error:any=""): Promise<any>{
    let that = this;
    let msg = new WebResponesContext();
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.ConfigName = "UpdateStoreLongitudeAndLatitude";
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Type = null;
    body.Client.Name = "product";
    body.Client.ClientType = 1;
    let _obj = {};
    _obj["ClockInState"]=state;
    _obj["AttendanceType"]=type;
    _obj["StoreID"] = that.com.GetStorageKey("tbstore")["ID"];
    _obj["StoreLongitude"] =long;
    _obj["StoreLatitude"] = lat;
    _obj["ClockAddress"] = obj.Address;
    _obj["ClockLongitude"] = obj.a_Longitude;
    _obj["ClockLatitude"] = obj.a_Latitude;
    _obj["msg"] = error;
    body.RequestBody = JSON.stringify(_obj);
    return new Promise<any>((resolve, reasole) => {
      that.http.post(app.DEFAULTURL, body).then(data => {
        if (data.ResponseMessage.Success) {
          msg.Status=data.Status;
          resolve(msg);
        } else {
          msg.ResponseMessage.Success=false;
          msg.ResponseMessage.ErrorMessage=data.ResponseMessage.ErrorMessage;
          reasole(msg);
        }
      }).catch(error => {
            msg.ResponseMessage.Success=false;
            msg.ResponseMessage.ErrorMessage="请求数据异常，请联系管理员";
          reasole(msg);
      });
    });

   }
  /**
   * pg 上班打卡
   */
  clockIn(url) {
    const that = this;
    that.msg.Loading("请稍后...").then(loads=>{
      that.getLocationInfo().then(data=>{
      // debugger;
        if(data){
          let _lat = 0;
          let _lng = 0;
          let _address="";
          let timetype =""; // 获取排班是什么类型
          let pgInfo = that.com.GetStorageKey("pginfo");
          if(pgInfo){
            _lat = pgInfo["c_Latitude"]||0;
            _lng = pgInfo["c_Longitude"]||0;
            _address = pgInfo["c_StreetAddress"];
            timetype = pgInfo["b_Code"]; // 获取排班是什么类型
          }
          let num = that.getCoordinateDifference(_lng, _lat);
          that.locationObject.num = num;
          localStorage.setItem("nowmapdetail",JSON.stringify(that.locationObject));//存储现在地图信息
          console.log(data,"getCoordinateDifference");
          if(_lat && _lng){
            console.log(timetype,"排班的地址显示")
            //判断是否是会议判断类型  如果是会议培训/或者活动支持 不做1000米打卡限制
               if(timetype == "T010" ||  timetype == "T011" ){
                const obj = {
                  type:"clockIn",
                  lat:that.locationObject.a_Latitude,
                  lng:that.locationObject.a_Longitude,
                  Address:that.locationObject.Address,
                  InDeviationNumber:that.locationObject.a_InDeviationNumber || 0,
                  isLocationSucess:true
                };
                try{
                  that.CloinId(0,1,that.locationObject).then(data=>{
                    console.log(data);
                }).catch(err=>{
                  console.log(err);
                });
                }catch(err){
                  console.log(err);
                }
                localStorage.setItem("clockLocation",JSON.stringify(obj));
  
                loads.dismiss();  
                that.com.setHistoryUrl();
                that.com.Go(url + "/" + that.com.getNowDatetime);
               }else{
                if(num <= app.LOCATIONLENGTH){
                  // debugger;
                //   //定位距离异常
                  const obj = {
                    type:"clockIn",
                    lat:that.locationObject.a_Latitude,
                    lng:that.locationObject.a_Longitude,
                    Address:that.locationObject.Address,
                    InDeviationNumber:that.locationObject.a_InDeviationNumber || 0,
                    isLocationSucess:true
                  };
                  try{
                    that.CloinId(0,1,that.locationObject).then(data=>{
                      console.log(data);
                  }).catch(err=>{
                    console.log(err);
                  });
                  }catch(err){
                    console.log(err);
                  }
                  localStorage.setItem("clockLocation",JSON.stringify(obj));
    
                  loads.dismiss();  
                  that.com.setHistoryUrl();
                  that.com.Go(url + "/" + that.com.getNowDatetime);
                }
                else{
                  loads.dismiss(); 
                  try{
                    that.CloinId(0,0,that.locationObject).then(data=>{
                      console.log(data);
                  }).catch(err=>{
                    console.log(err);
                  });
                  }catch(err){
                    console.log(err);
                  }
                  
                  that.msg.Alert("您的打卡范围超过"+app.LOCATIONLENGTH+"米");
                  // that.com.setHistoryUrl();
                  // localStorage.setItem("nowmapdetail",JSON.stringify(that.locationObject));//存储现在地图信息
                  // that.router.navigate(['/mapdetail-page/'+that.com.getNowDatetime]);
                  // console.log(that.map_container.nativeElement,"未知未知未知");
                  
                  // return;
                //   //保存上班打卡数据
                //   // loads.dismiss();  
                //   that.clockInApi(loads);
                //   // that.router.navigateByUrl(url + "/" + that.com.getNowDatetime);
                }
               }
            // let num = that.getCoordinateDifference(data.location.lng, data.location.lat);
            
          }else{

            //如果门店坐标不存在，并门店地址不存在则请求接口获取门店坐标 并于当前坐标比对 如超过配置得距离则不能上班。
            that.map.getGDAddressPosition(that.map_container.nativeElement,_address).then(data=>{
              // debugger;
              console.log(data,"获取坐标***");
                _lat = data.lat||0;
                _lng = data.lng||0;
                let timetype = "";
                let pgInfo = that.com.GetStorageKey("pginfo")||{};
                if(pgInfo){
                    pgInfo["c_Latitude"]=_lat;
                    pgInfo["c_Longitude"]=_lng;
                 localStorage.setItem("pginfo",JSON.stringify(pgInfo));
                 timetype = pgInfo["b_Code"];
                }
                let isSuccess = that.getlicationList(_lng,_lat);
                loads.dismiss(); 
                  // 如果是会议培训/或者活动支持 不做1000米打卡限制
                  if(timetype == "T010" ||  timetype == "T011" ){
                    that.com.setHistoryUrl();
                    // that.router.navigateByUrl(url + "/" + that.com.getNowDatetime);
                    that.com.Go(url + "/" + that.com.getNowDatetime);
                  }else{
                    if(isSuccess){
                      that.com.setHistoryUrl();
                      // that.router.navigateByUrl(url + "/" + that.com.getNowDatetime);
                      that.com.Go(url + "/" + that.com.getNowDatetime);
                    }else{
                      that.msg.Alert("您的打卡范围超过"+app.LOCATIONLENGTH+"米");
                      // that.com.setHistoryUrl();
                      // localStorage.setItem("nowmapdetail",JSON.stringify(that.locationObject));//存储现在地图信息
                      // that.router.navigate(['/mapdetail-page/'+that.com.getNowDatetime]);
                    }
                  }
              
               
            }).catch(err=>{
              const obj = {
                type:"clockIn",
                lat:that.locationObject.a_Latitude,
                lng:that.locationObject.a_Longitude,
                Address:that.locationObject.Address,
                InDeviationNumber:that.locationObject.a_InDeviationNumber || 0,
                isLocationSucess:true
              };
              try{
                that.CloinId(0,0,that.locationObject,0,0,err).then(data=>{
                  console.log(data);
              }).catch(err=>{
                console.log(err);
              });
              }catch(err){
                console.log(err);
              }
              // localStorage.setItem("clockLocation",JSON.stringify(obj));
              loads.dismiss();  
              // that.com.setHistoryUrl();
              // that.router.navigateByUrl(url + "/" + that.com.getNowDatetime);
              that.msg.Alert("您的门店地址有误，请联系管理员！");
              return;
            });
          }
          
        }
        else{
          // return;
          //定位失败-到二级页面填写信息签到
          const obj = {
            type:"clockIn",
            lat:0,
            lng:0,
            Address:null,
            InDeviationNumber:0,
            isLocationSucess:false
          };
          localStorage.setItem("clockLocation",JSON.stringify(obj));
          try{
            that.CloinId(0,0,that.locationObject).then(data=>{
              console.log(data);
          }).catch(err=>{
            console.log(err);
          });
          }catch(err){
            console.log(err);
          }
          loads.dismiss();
          that.com.setHistoryUrl();
          // that.router.navigateByUrl(url + "/" + that.com.getNowDatetime);
          that.com.Go(url + "/" + that.com.getNowDatetime);
          // that.msg.Alert("获取当前位置失败，请检查您的定位权限是否开启！");
          return;
        }
      }).catch(error=>{
        loads.dismiss();
        if(!app.ISGPSLOCATION){
          that.msg.Alert("请开启手机定位权限");
          return;
        }

      
        //定位失败-到二级页面填写信息签到
        const obj = {
          type:"clockIn",
          lat:0,
          lng:0,
          Address:null,
          InDeviationNumber:0,
          isLocationSucess:false
        };
        localStorage.setItem("clockLocation",JSON.stringify(obj));
        try{
          that.CloinId(0,0,that.locationObject,0,0,"获取门店坐标失败").then(data=>{
            console.log(data);
        }).catch(err=>{
          console.log(err);
        });
        }catch(err){
          console.log(err);
        }
        that.com.setHistoryUrl();
        // that.router.navigateByUrl(url + "/" + that.com.getNowDatetime);
        that.com.Go(url + "/" + that.com.getNowDatetime);
        // that.msg.Alert("获取当前位置失败，请检查您的定位权限是否开启！");
        return;
      })
      loads.present();
    })
  }
  /**
   * pg 下班打卡
   */
  clockOut(url) {
    const that = this;
    
    that.msg.Loading("请稍后...").then(loads=>{
      that.getLocationInfo().then(data=>{
        if(data){
          console.log(data,"getCoordinateDifference");
          let pgInfo = that.com.GetStorageKey("pginfo");
          let _lat = 0;
          let _lng = 0;
          let _address="";
          let timetype =""; // 获取排班是什么类型
          if(pgInfo){
            _lat = pgInfo["c_Latitude"]||0;
            _lng = pgInfo["c_Longitude"]||0;
            _address = pgInfo["c_StreetAddress"];
            timetype = pgInfo["b_Code"]; // 获取排班是什么类型
          }
          let num = that.getCoordinateDifference(_lng, _lat);
          that.locationObject.num = num;
          localStorage.setItem("nowmapdetail",JSON.stringify(that.locationObject));//存储现在地图信息
          if(_lat && _lng){
            console.log(timetype,"排班的地址显示")
            //判断是否是会议判断类型  如果是会议培训/或者活动支持 不做1000米打卡限制
               if(timetype == "T010" ||  timetype == "T011" ){
                const obj = {
                  type:"clockOut",
                  lat:that.locationObject.a_Latitude,
                  lng:that.locationObject.a_Longitude,
                  Address:that.locationObject.Address,
                  InDeviationNumber:that.locationObject.a_InDeviationNumber || 0,
                  isLocationSucess:true
                };
                localStorage.setItem("clockLocation",JSON.stringify(obj));
                loads.dismiss();  
                try{
                  that.CloinId(1,1,that.locationObject).then(data=>{
                    console.log(data);
                }).catch(err=>{
                  console.log(err);
                });
                }catch(err){
                  console.log(err);
                }
                that.com.setHistoryUrl();
                // that.router.navigateByUrl(url + "/" + that.com.getNowDatetime);
                that.com.Go(url + "/" + that.com.getNowDatetime);
               }else{
                            // let num = that.getCoordinateDifference(_lng,_lat);
                  if(num <= app.LOCATIONLENGTH){
                    //定位距离异常
                    const obj = {
                      type:"clockOut",
                      lat:that.locationObject.a_Latitude,
                      lng:that.locationObject.a_Longitude,
                      Address:that.locationObject.Address,
                      InDeviationNumber:that.locationObject.a_InDeviationNumber || 0,
                      isLocationSucess:true
                    };
                    localStorage.setItem("clockLocation",JSON.stringify(obj));
                    loads.dismiss();  
                    try{
                      that.CloinId(1,1,that.locationObject).then(data=>{
                        console.log(data);
                    }).catch(err=>{
                      console.log(err);
                    });
                    }catch(err){
                      console.log(err);
                    }
                    that.com.setHistoryUrl();
                    // that.router.navigateByUrl(url + "/" + that.com.getNowDatetime);
                    that.com.Go(url + "/" + that.com.getNowDatetime);
                  }else{
                    try{
                      that.CloinId(1,0,that.locationObject,0,0,"您的打卡范围超过"+app.LOCATIONLENGTH+"米").then(data=>{
                        console.log(data);
                    }).catch(err=>{
                      console.log(err);
                    });
                    }catch(err){
                      console.log(err);
                    }
                    loads.dismiss(); 
                    localStorage.setItem("nowmapdetail",JSON.stringify(that.locationObject));//存储现在地图信息
                    that.msg.Alert("您的打卡范围超过"+app.LOCATIONLENGTH+"米");
                    return;
                      // that.com.setHistoryUrl();
                      // localStorage.setItem("nowmapdetail",JSON.stringify(that.locationObject));//存储现在地图信息
                      // that.router.navigate(['/mapdetail-page/'+that.com.getNowDatetime]);
                  //   //保存下班班打卡数据
                  //   // loads.dismiss();  
                  //   that.clockOutApi(loads);
                  //   // that.router.navigateByUrl(url + "/" + that.com.getNowDatetime);
                }
               }
            
          }else{
            that.map.getGDAddressPosition(that.map_container.nativeElement,_address).then(data=>{
              console.log(data,"&&&&&&&&&&&&坐标");
              let num = that.getCoordinateDifference(data.lng, data.lat);
                _lat = data.lat||0;
                _lng = data.lng||0;
                let timetype = "";
                let pgInfo = that.com.GetStorageKey("pginfo")||{};
                if(pgInfo){
                    pgInfo["c_Latitude"]=_lat;
                    pgInfo["c_Longitude"]=_lng;
                 localStorage.setItem("pginfo",JSON.stringify(pgInfo));
                 timetype = pgInfo["b_Code"];

                }
                let isSuccess = that.getlicationList(_lng,_lat,"clockOut");
                loads.dismiss(); 
                  // 如果是会议培训/或者活动支持 不做1000米打卡限制
                  if(timetype == "T010" ||  timetype == "T011" ){
                    that.com.setHistoryUrl();
                    // that.router.navigateByUrl(url + "/" + that.com.getNowDatetime);
                    that.com.Go(url + "/" + that.com.getNowDatetime);
                  }else{
                    if(isSuccess){
                      that.com.setHistoryUrl();
                      // that.router.navigateByUrl(url + "/" + that.com.getNowDatetime);
                      that.com.Go(url + "/" + that.com.getNowDatetime);
                    }else{
                      that.msg.Alert("您的打卡范围超过"+app.LOCATIONLENGTH+"米");
                      // that.com.setHistoryUrl();
                      // localStorage.setItem("nowmapdetail",JSON.stringify(that.locationObject));//存储现在地图信息
                      // that.router.navigate(['/mapdetail-page/'+that.com.getNowDatetime]);
                    }
                  }
              
               
            }).catch(err=>{
              const obj = {
                type:"clockOut",
                lat:that.locationObject.a_Latitude,
                lng:that.locationObject.a_Longitude,
                Address:that.locationObject.Address,
                InDeviationNumber:that.locationObject.a_InDeviationNumber || 0,
                isLocationSucess:true
              };
              loads.dismiss(); 
              // localStorage.setItem("clockLocation",JSON.stringify(obj));
              // loads.dismiss();  
              // that.com.setHistoryUrl();
              // that.router.navigateByUrl(url + "/" + that.com.getNowDatetime);
              that.msg.Alert("您的门店地址有误，请联系管理员！");
              return;
            });
            that.CloinId(1,0,that.locationObject,0,0,"获取门店坐标失败").then((data) => {
              console.log(data);
            }).catch(data=>{
              console.log(data);
            });
          }
          
        }else{
          //定位失败-到二级页面填写信息签到
          const obj = {
            type:"clockOut",
            lat:0,
            lng:0,
            Address:null,
            InDeviationNumber:0,
            isLocationSucess:false
          };
          localStorage.setItem("clockLocation",JSON.stringify(obj));
          try{
            that.CloinId(1,0,that.locationObject).then(data=>{
              console.log(data);
          }).catch(err=>{
            console.log(err);
          });
          }catch(err){
            console.log(err);
          }
          
          loads.dismiss();
          that.com.setHistoryUrl();
          // that.router.navigateByUrl(url + "/" + that.com.getNowDatetime);
          that.com.Go(url + "/" + that.com.getNowDatetime);
          // that.msg.Alert("获取当前位置失败，请检查您的定位权限是否开启！");
          return;
        }
      }).catch(err=>{
        console.log(err,"定位权限问题");
        loads.dismiss();
        if(!app.ISGPSLOCATION){
          that.msg.Alert("请开启手机定位权限");
          return;
        }
        //定位失败-到二级页面填写信息签到
        const obj = {
          type:"clockOut",
          lat:0,
          lng:0,
          Address:null,
          InDeviationNumber:0,
          isLocationSucess:false
        };
        localStorage.setItem("clockLocation",JSON.stringify(obj));
        try{
          that.CloinId(1,0,that.locationObject).then(data=>{
            console.log(data);
        }).catch(err=>{
          console.log(err);
        });
        }catch(err){
          console.log(err);
        }
        that.com.setHistoryUrl();
        // that.router.navigateByUrl(url + "/" + that.com.getNowDatetime);
        that.com.Go(url + "/" + that.com.getNowDatetime);
        // that.msg.Alert("获取当前位置失败，请检查您的定位权限是否开启！");
        return;
      })
      loads.present();
    })
  }

    /**
   * 获取定位信息
   */
  getLocationInfo(): Promise<any>{
    const that = this;
    return new Promise<any>((resolve, reasole)=>{
      if (that.platform.is("cordova")) {
        that.map.getGDCurrentPosition().then(data => {
          that.locationError = false;
          that.locationObject.Address = that.com.GetChineselanage(data.address);
          that.locationObject.a_Latitude = data.latitude;
          that.locationObject.a_Longitude = data.longitude;
          localStorage.setItem("nowmapdetail",JSON.stringify(that.locationObject));//存储现在地图信息
          resolve(true);
        }).catch(error => {
          that.locationError = true;
          console.log("定位失败,请联系管理员");
          resolve(false);
        });
      } else {
        that.locationObject.Address ="";
        that.locationObject.a_Latitude = 0;
        that.locationObject.a_Longitude = 0;
        that.map.Geolocation(that.map_container.nativeElement).then(data => {
        console.log(data,"定位成功");
          // loads.dismiss();
          that.locationError = false;
          that.locationObject.Address = that.com.GetChineselanage(data.formattedAddress);
          that.locationObject.a_Latitude = data.position.lat;
          that.locationObject.a_Longitude = data.position.lng;
          localStorage.setItem("nowmapdetail",JSON.stringify(that.locationObject));//存储现在地图信息
          resolve(true);
        }).catch(error => {
          that.locationError = true;
          console.log(error,"定位失败");
          if(error.type && error.type=="error"){
              if(error.message.indexOf("permission")>=0 || error.message.indexOf("ipLocation")>=0){//如果提示定位权限问题则直接提示请开启定位权限
                reasole(false);
              }else{
                reasole(false);
              }
          }else{
            reasole(false);
          }
          // loads.dismiss();
        });
      }
    })
  }
  /**
   * 更新门店坐标
   * @param _lng 
   * @param _lat 
   *  @param _type 判断上班下班 
   */
  getlicationList(_lng:any,_lat:any,_type:any="clockIn"):boolean{
    // debugger;
    const that=this;
    let result:boolean=false;
    let num = that.getCoordinateDifference(_lng,_lat);
    that.locationObject.num=num;
    if(num <= app.LOCATIONLENGTH){
      //定位距离异常
      const obj = {
        type:_type,
        lat:that.locationObject.a_Latitude,
        lng:that.locationObject.a_Longitude,
        Address:that.locationObject.Address,
        InDeviationNumber:that.locationObject.a_InDeviationNumber || 0,
        isLocationSucess:true
      };
      try{
        that.CloinId(0,1,that.locationObject,_lng,_lat).then(data=>{
          console.log(data);
      }).catch(err=>{
        console.log(err);
      });
      }catch(err){
        console.log(err);
      }
      localStorage.setItem("clockLocation",JSON.stringify(obj));
      result=true;
    }else{
      try{
        that.CloinId(0,0,that.locationObject,_lng,_lat,"您的打卡范围超过"+app.LOCATIONLENGTH+"米").then(data=>{
          console.log(data);
      }).catch(err=>{
        console.log(err);
      });
      }catch(err){
        console.log(err);
      }
    }
    return result;
   }
  /**
   * 获取定位差距
   */
  getCoordinateDifference(lng,lat){
    const that = this;
    let _num = that.com.Dist(
      that.locationObject.a_Longitude,
      that.locationObject.a_Latitude,
      lng,lat);
      that.locationObject.a_InDeviationNumber = _num;
      console.log(_num.toFixed(2),"_num");
      return _num;
  }

  /**
   * 保存上班信息
   */
  clockInApi(loads){
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.ConfigName = "TBScheduleNormalXML";//总表
    body.OpType = "Edite";
    body.ConfigType = "form";
    body.Client.PageName = "ClockIn";
    body.Client.ApiType = "Content";
    body.Client.Type = "add";
    body.Client.Name = "Element";
    body.Client.ClientType = 1;
    body["SpecialParameter"] = "clockIn";
    const info:any = localStorage.getItem("pginfo");
    const anyinfo = JSON.parse(info)||{};
    let _obj = {};
    //TODO:上班参数
    _obj["a_id"] = anyinfo["a_ID"];
    _obj["a_StartAddress"] = that.locationObject.Address;
    _obj["a_StartLong"] =that.locationObject.a_Longitude;
    _obj["a_StartLat"] = that.locationObject.a_Latitude;
    _obj["a_InDeviationNumber"] = that.locationObject.a_InDeviationNumber;
    _obj["a_SNStartDate"] = anyinfo["a_SNStartDate"];
    body.RequestBody = JSON.stringify(_obj);
    return;
    that.http.post(app.DEFAULTURL, body).then(data => {
      loads.dismiss();
      if (data.ResponseMessage.Success) {
       
        //TODO:上班结束逻辑
        localStorage.removeItem("clock");
        localStorage.removeItem("clockOut");
        localStorage.setItem("pgindata","true");
        localStorage.removeItem("pgondate");
        const StartDate = data.Status["StartDate"] || "";
        const info:any = localStorage.getItem("pginfo")||{};
        const anyinfo = JSON.parse(info)||{};
              anyinfo["a_StartDate"]=StartDate;
        if(data.Status["PunchLong"] && data.Status["PunchLat"]){
          anyinfo["c_Longitude"]=data.Status["PunchLong"];
          anyinfo["c_Latitude"]=data.Status["PunchLat"];
        }
              localStorage.setItem("pginfo",JSON.stringify(anyinfo));
        that.emitservice.eventEmitClockInOrOut.emit("clockIn");
        that.element.badgeCount = 1;//表示已上班
        // that.msg.Alert("上班成功！");
      } else {
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
    }).catch(error => {
      loads.dismiss();
      that.msg.Alert(app.ERRORMESSAGE);
    });
  }

  /**
   * 保存下班信息
   */
  clockOutApi(loads){
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.ConfigName = "TBScheduleNormalXML";//总表
    body.OpType = "Edite";
    body.ConfigType = "form";
    body.Client.PageName = "ClockOut";
    body.Client.ApiType = "Content";
    body.Client.Type = "add";
    body.Client.Name = "Element";
    body.Client.ClientType = 1;
    body.SpecialParameter = "clockOut";
    const info:any = localStorage.getItem("pginfo")||{};
    const anyinfo = JSON.parse(info)||{};
    let _obj = {};
    //TODO:下班参数
    _obj["a_id"] = anyinfo["a_ID"];
    _obj["a_EndAddress"] = that.locationObject.Address;
    _obj["a_EndLong"] =that.locationObject.a_Longitude;
    _obj["a_EndLat"] = that.locationObject.a_Latitude;
    _obj["a_OnDeviationNumber"] = that.locationObject.a_InDeviationNumber;
    _obj["a_SNEndDate"] = anyinfo["a_SNEndDate"];
    body.RequestBody = JSON.stringify(_obj);
    console.log(_obj,"定位canshujihe")
    return;
    that.http.post(app.DEFAULTURL, body).then(data => {
      loads.dismiss();
      if (data.ResponseMessage.Success) {
        
        //TODO:下班结束逻辑
        localStorage.removeItem("clock");
        localStorage.removeItem("clockOut");
        localStorage.setItem("pgondate","true");
        const EndDate = data.Status["EndDate"] || "";
        const info:any = localStorage.getItem("pginfo")||{};
        const anyinfo = JSON.parse(info)||{};
              anyinfo["a_EndDate"]=EndDate;
        if(data.Status["PunchLong"] && data.Status["PunchLat"]){
          anyinfo["c_Longitude"]=data.Status["PunchLong"];
          anyinfo["c_Latitude"]=data.Status["PunchLat"];
        }
        localStorage.setItem("pginfo",JSON.stringify(anyinfo));
        that.emitservice.eventEmitClockInOrOut.emit("clockOut");
        that.element.badgeCount = 1;//表示已下班
        // that.msg.Alert("下班成功！");
      } else {
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
    }).catch(error => {
      loads.dismiss();
      that.msg.Alert(app.ERRORMESSAGE);
    });
  }
  /**
   * 如果 SNC二维码不存在就请求此接口调用
   */
  SNCInfo(){
    const that=this;
    let body = new WebParameterContext();
    body.ConfigName = "SNCQrcodeManage";
    body.OpType = "add";
    body.ConfigType = "form";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = "ScanCodeSales";
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    that.msg.Loading("二维码生成中，请稍后...").then(load=>{
      that.http.post(app.DEFAULTURL, body).then(
        data => {
          load.dismiss();
          if(data.ResponseMessage.Success){
            console.log(data,"结果");
            that.com.setHistoryUrl(false);
            let urlInfo:any = data.Status.Datas[0].QR;
            if(urlInfo){
              let userinfo:SysAccount = that.com.GetAccount;
                   userinfo.Qrcode=urlInfo;
              localStorage.setItem("account",JSON.stringify(userinfo));
              let _imgurl:any = urlInfo.replace("/placeholder","");
              let _url:any=app.WEBURL+"/"+_imgurl;
              that.com.goQrCode(_url,"ismycode");
            }else{
              that.msg.Alert("未提供SNC二维码");
            }
           
          }else{
            that.msg.Alert(data.ResponseMessage.ErrorMessage);
          }
        }
      ).catch(error => {
        load.dismiss();
        that.msg.Alert(error.ResponseMessage.ErrorMessage);
        console.log(error);
      });
      load.present();
    });
  }
  
  
}
